
class Constants {
    readonly pageSize: number = 10;
    readonly WHATSAPP: string = 'WhatsApp';
    readonly WHATSAPP_MESSAGE: string = 'Mensaje WhatsApp';

    readonly envRelease = 'release';
    readonly colorDevelop = 'd32f2f';
    readonly colorRelease = 'ffa000';
    readonly whatsappLink: string = 'https://wa.me';
    readonly sectionsFileLimit: number = 4;
    readonly productsFileLimit: number = 5;
}

const constants = new Constants();
export default constants;
